import React from 'react';
import './legend.css';

interface LegendProps {
  min: number;
  max: number;
  title: string;
  unit?: string;
  reverse?: boolean;
  fixedRange?: { min: number; max: number }; // ← namiesto isFixedRange
}

const scaleColors = ["#CD5B45", "#E69F7D", "#FFE4B5", "#A9B784", "#548B54"];

const Legend: React.FC<LegendProps> = ({
  min,
  max,
  title,
  unit,
  reverse = false,
  fixedRange
}) => {
  // ak je fixedRange, použijeme ho; inak dynamické min/max z mapy
  const rangeMin = fixedRange ? fixedRange.min : min;
  const rangeMax = fixedRange ? fixedRange.max : max;

  const gradient = reverse
    ? `linear-gradient(to right,
        ${scaleColors[4]},
        ${scaleColors[3]},
        ${scaleColors[2]},
        ${scaleColors[1]},
        ${scaleColors[0]}
      )`
    : `linear-gradient(to right,
        ${scaleColors[0]},
        ${scaleColors[1]},
        ${scaleColors[2]},
        ${scaleColors[3]},
        ${scaleColors[4]}
      )`;

  return (
    <div className="legend">
      <h4>{title}</h4>
      <div
        style={{
          background: gradient,
          height: '12px',
          width: '200px',
          borderRadius: '6px',
          marginBottom: '5px'
        }}
      />
      <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px' }}>
        <span>{rangeMin} {unit}</span>
        <span>{rangeMax} {unit}</span>
      </div>
    </div>
  );
};

export default Legend;
